import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Routes, useNavigate } from 'react-router-dom';
import QueryCatalog from './QueryCatalog';
import QueryFormWrap from './QueryFormWrap';
import QueryReport from './QueryReport';
import QueryContext from './query-context';
import { getQueryCatalogRequest } from '../../../../redux/actions/supportActions';

function UnconnectedQuerySPA(props) {
  const [catalog, setCatalog] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    props.dispatch(
      getQueryCatalogRequest({
        setStateFunc: setCatalog,
      })
    );
  }, []); // eslint-disable-line

  function onSubmit(item, formData) {
    item.formData = formData;
    const catClone = [...catalog];
    setCatalog(catClone);
    navigate(`${item.id}/report`);
  }

  function onToggleChildren(item) {
    item.displayChildren = !item?.displayChildren;
    const catClone = [...catalog];
    setCatalog(catClone);
  }

  const QueryFormRoute = () => {
    return <QueryFormWrap />;
  };

  const QueryReportRoute = () => {
    return <QueryReport />;
  };

  return (
    <QueryContext.Provider value={{ catalog, onToggleChildren, onSubmit }}>
      <Routes>
        <Route path=":id/form" element={<QueryFormRoute />} />
        <Route path=":id/report" element={<QueryReportRoute />} />
        <Route path="/" element={<QueryCatalog />} />
      </Routes>
    </QueryContext.Provider>
  );
}

export default connect()(UnconnectedQuerySPA);
